import {
  NodeEditorHeader,
  NodeEditorHeaderProps,
} from 'modules/workflows/components/NodeEditor/NodeEditorHeader';
import { FormSectionContent } from 'modules/workflowNodeEditors/EditorBody.styled';

export interface SectionTitleProps {
  /** The title shown in section header */
  title?: string;
  /**
   * Section banner
   * This is useful for showing errors, warnings or other information
   */
  banner?: JSX.Element;
  /** The component to use for the header element */
  HeaderCmp?: React.FC<React.PropsWithChildren<NodeEditorHeaderProps>>;
}

export const SectionTitle = ({
  title,
  banner,
  HeaderCmp = NodeEditorHeader,
}: SectionTitleProps) => {
  return (
    <>
      {title && <HeaderCmp title={title} />}
      {banner && <FormSectionContent>{banner}</FormSectionContent>}
    </>
  );
};

export default SectionTitle;
